/**
 * 串口选择器组件
 * 显示可用串口列表并提供选择功能
 */
import { useSerialPorts } from '@/hooks/use-serial-ports';
import { useConnectionStore } from '@/stores/connection';
import { ChevronDown } from 'lucide-react';
import * as Select from '@radix-ui/react-select';

/** 串口选择器：列出可用串口供用户选择 */
export function PortSelector() {
  const { ports, selectedPort, setPort } = useSerialPorts();
  const isConnected = useConnectionStore((s) => s.state === 'connected');

  return (
    <Select.Root value={selectedPort || ''} onValueChange={setPort} disabled={isConnected}>
      <Select.Trigger
        aria-label="串口"
        className="inline-flex h-9 min-w-[168px] items-center justify-between gap-2 rounded border border-surface-700
          bg-surface-800 px-3 text-xs text-surface-200 data-[placeholder]:text-surface-500
          focus:border-accent-500 disabled:cursor-not-allowed disabled:opacity-50"
      >
        <Select.Value placeholder="选择串口…" />
        <Select.Icon>
          <ChevronDown className="w-4 h-4 text-surface-500" />
        </Select.Icon>
      </Select.Trigger>
      <Select.Portal>
        <Select.Content
          className="z-50 overflow-hidden rounded-md border border-surface-600 bg-surface-800 shadow-2xl"
          position="popper"
        >
          <Select.Viewport className="p-1">
            {ports.length === 0 && (
              <Select.Item value="" disabled className="px-3 py-2 text-sm text-surface-500">
                未检测到串口
              </Select.Item>
            )}
            {ports.map((port) => (
              <Select.Item
                key={port.path}
                value={port.path}
                className="cursor-pointer rounded px-3 py-2 text-sm text-surface-200 outline-none hover:bg-surface-700
                  data-[state=checked]:bg-accent-500/10 data-[state=checked]:text-accent-300"
              >
                <Select.ItemText>
                  {port.path}
                  {port.friendlyName && (
                    <span className="text-xs text-surface-500 ml-2">{port.friendlyName}</span>
                  )}
                </Select.ItemText>
              </Select.Item>
            ))}
          </Select.Viewport>
        </Select.Content>
      </Select.Portal>
    </Select.Root>
  );
}
